import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";


export class DashboardCollection extends CachingCollection<Backbone.Model> {

    url = () => {
        return window.location.origin + '/api/v1/dashboards';
    };

    comparator = (model) => {
        return model.get('name');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/Dashboards.ts